import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { fetchConToken } from "../../../helpers/fetch";

import {
  Button,
  Card,
  Fab,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";

import {
  anularFacturaAfiliado,
  facturasAfiliadoSeleccionadoLimpiar,
  fetchConsultaFacturacionAfiliado,
  fetchDetalleCompSeleccionado,
} from "../../../actions/facturacion/facturasAfiliado";
import { ModalDetalleComp } from "./ModalDetalleComp";
import { ListaCtaCtePDF } from "./ListaCtaCtePDF";
import { handleErrorApi } from "../../../helpers/randoms";
import { FACTURACION_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import CancelIcon from '@material-ui/icons/Cancel';
import { TIPO_COMPROBANTE } from "../../../utils/constants";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import { startAlerta } from "../../../actions/ui/alertas";
import { ModalObservacion } from "./ModalObservacion";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const ListaCtaCte = (props) => {
  const { items, cargada, consultaAfiliado, page, rowsPerPage, total, dense } = props;
  const { dni, permisos: permisosUser } = useSelector(state => state.auth)
  const dispatch = useDispatch();

  const [selected, setSelected] = useState([]);
  const [openModalObservacion, setOpenModalObservacion] = useState(false);
  const [observacionAnulacion, setObservacionAnulacion] = useState('');
  const [selectedFactAnular, setSelectedFactAnular] = useState();
  const [selectedFactObservacion, setSelectedFactObservacion] = useState();
  const [openModalDetComp, setOpenModalDetComp] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openValidation, setOpenValidation] = useState(false);
  const [numOrdenPago, setNumOrdenPago] = useState();
  const [dniUser, setDniUser] = useState('');

  const pdfRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => pdfRef.current,
  });

  const onClickBotonPagoHandler = async (comprobante) => {
    try {
      const parametros = `idAfiliado=${comprobante.idAfiliado}&idTipoComprobante=${comprobante.idTipoComprobante}&nroComprobante=${comprobante.nroComprobante}&fechaComprobante=${comprobante.fechaComprobante}`;
      const response = await fetchConToken(
        `BeneficiariosFacturas/traerIdCuponPago?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const idCuponPago = await response.json();
        if (response.status !== 200) throw idCuponPago.errores;
        setNumOrdenPago(idCuponPago);
        dispatch(fetchConsultaFacturacionAfiliado(idCuponPago, handlePrint));
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el Cupon de Pago",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

  const isSelected = (nroComprobante) =>
    selected.indexOf(nroComprobante) !== -1;

  const onClickRowHandler = (e, item) => {
    const onClickName = e.target.textContent;

    if (onClickName !== "Cupon Pago" && onClickName !== '')
      openModalDetalleComprobante(item)
  };

  const openModalDetalleComprobante = (item) => {
    dispatch(fetchDetalleCompSeleccionado(item));
    setSelected([item.nroComprobante]);
    setOpenModalDetComp(true);
  };

  const handleOpenConfirmAnularFactura = (item) => {
    setOpenConfirmation(true);
    setSelectedFactAnular(item);
  };

  const handleCloseConfirmation = () => {
    setOpenConfirmation(false);
    resetValues();
  }

  const handleSendConfirmation = () => {
    if(observacionAnulacion !== ''){
      setOpenConfirmation(false);
      setOpenValidation(true);
    }else{
      dispatch( startAlerta("Se debe incluir un motivo de cancelación", "error") );
    }
  }

  const handleSendValidation = () => {
    if(dni !== parseInt(dniUser)){
      dispatch( startAlerta("El DNI ingresado no coincide con el del usuario logueado", "error") );
    }else{
      dispatch( 
          anularFacturaAfiliado(
              selectedFactAnular.idAfiliado
              ,selectedFactAnular.idTipoComprobante
              ,selectedFactAnular.nroComprobante
              ,selectedFactAnular.fechaComprobante
              ,observacionAnulacion     
          )
      );
      setOpenValidation(false);
      resetValues();
    }
  }

  const handleCloseValidation = () => {
    setOpenValidation(false);
    resetValues();
  }

  const resetValues = () => {
    setDniUser('');
    setSelectedFactAnular();
    setObservacionAnulacion('');
  }

  const handleClose = () => {
    dispatch(facturasAfiliadoSeleccionadoLimpiar());
    setOpenModalDetComp(false);
    setSelected([]);
  };

  const handleOpenModalObservacion = (item) => {
    setOpenModalObservacion(true);
    setSelectedFactObservacion(item);
  }

  const visibleAnular = () => {
    if(validarSoloUnPermiso(permisosUser, FACTURACION_PERMISOS.ANULACION))
      return true;
    else
      return false;
  }

  return (
    <>
      {cargada && (
        <React.Fragment>
          <div style={{ display: "none" }}>
            <ListaCtaCtePDF ref={pdfRef} numOrdenPago={numOrdenPago}/>
          </div>
          <Card>
            <ModalDetalleComp
              open={openModalDetComp}
              close={handleClose}
              comprobante={items.find((s) => s.nroComprobante === selected[0])}
            />
            <ModalObservacion
              open={openModalObservacion}
              item={selectedFactObservacion}
              handleClose={() => setOpenModalObservacion(false)}
            />
            <TableContainer
              component={Paper}
              style={{ marginLeft: 15, marginTop: 5, paddingRight: 35 }}
            >
              <Table size={dense ? "small" : "medium"}>
                <TableHead>
                  <TableRow>
                    {visibleAnular() && (
                      <TableCell></TableCell>
                    )}
                    <TableCell align="left">Fecha</TableCell>
                    <TableCell align="left">Nro Comprobante</TableCell>
                    <TableCell align="left">Tipo</TableCell>
                    <TableCell align="left">Periodo</TableCell>
                    <TableCell align="left">Fecha Vencimiento</TableCell>
                    <TableCell align="center" style={{ minWidth: 100 }}>
                      Importe
                    </TableCell>
                    <TableCell align="center" style={{ minWidth: 80 }}>
                      Interés
                    </TableCell>
                    <TableCell align="center">Saldo</TableCell>
                    <TableCell align="center"></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.length > 0 ? (
                    <>
                      {items
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((item, i) => {
                          const isItemSelected = isSelected(
                            item.nroComprobante
                          );

                          return (
                            <TableRow
                              hover
                              selected={isItemSelected}
                              key={item.nroComprobante2}
                              onClick={(e) => onClickRowHandler(e, item)}
                            >
                              {visibleAnular() && (
                                <TableCell style={{paddingTop: 0, paddingBottom: 0}}>
                                  {
                                    item.importe === item.saldo &&
                                    item.idTipoComprobante === item.idTipoComprobante2 && 
                                    item.idTipoComprobante === TIPO_COMPROBANTE.FACTURA &&(
                                    
                                      <Tooltip title="Anular Factura">
                                        <Fab
                                          size="small"
                                          disabled={item.importe !== item.saldo}
                                          style={{backgroundColor: '#f7f2f2'}}
                                          onClick={() => handleOpenConfirmAnularFactura(item)}
                                        >
                                          <CancelIcon style={{fontSize: 30, color: 'red'}}/>
                                        </Fab>
                                      </Tooltip>
                                    )}
                                </TableCell>
                              )}
                              <TableCell
                                align="left"
                              >
                                {new Date(item.fechaComprobante2).toLocaleString(
                                  "es",
                                  optionsfecha
                                )}
                              </TableCell>
                              <TableCell
                                align="left"
                              >
                                {item.nroComprobante2}
                              </TableCell>
                              <TableCell
                                align="left"
                              >
                                {item.descripcionTipoComprobante}
                              </TableCell>
                              <TableCell
                                align="left"
                              >
                                {item.periodo.toLocaleString("en-US", {
                                  minimumIntegerDigits: 6,
                                  useGrouping: false,
                                })}
                              </TableCell>
                              <TableCell
                                align="center"
                              >
                                {new Date(item.fechaVencimiento).toLocaleString(
                                  "es",
                                  optionsfecha
                                )}
                              </TableCell>
                              <TableCell
                                align="right"
                              >
                                {`$ ${item.importe.toFixed(2)}`}
                              </TableCell>
                              <TableCell
                                align="right"
                              >
                                {`$ ${item.interes.toFixed(2)}`}
                              </TableCell>
                              <TableCell
                                align="right"
                                style={{ paddingRight: 20 }}
                              >
                                {`$ ${item.saldoConInteres.toFixed(2)}`}
                              </TableCell>
                              <TableCell align="left">
                                {item.idTipoComprobante === 1 &&
                                  item.saldo > 0 && (
                                    <Button
                                      variant="contained"
                                      style={{
                                        marginLeft: 10,
                                        minWidth: 125,
                                        marginRight: -20,
                                      }}
                                      onClick={() =>
                                        onClickBotonPagoHandler(item)
                                      }
                                      color="primary"
                                    >
                                      Cupon Pago
                                    </Button>
                                  )}
                              </TableCell>
                              <TableCell>
                                {item.idTipoComprobante2 === TIPO_COMPROBANTE.ANULACION_FACTURA &&
                                  <IconButton 
                                    style={{paddingTop: 0, paddingBottom: 0, marginLeft: 0, marginRight: -10}}
                                    onClick={() => handleOpenModalObservacion(item)}
                                    color="secondary" 
                                    aria-label="Observaciones" 
                                    component="span"
                                  >
                                    <LibraryBooksIcon />
                                  </IconButton>
                                }
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      <TableRow key={consultaAfiliado.id_afiliado}>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right" style={{ minWidth: 145 }}>
                          <strong>TOTAL ${total.toFixed(2)}</strong>
                        </TableCell>
                      </TableRow>
                    </>
                  ) : (
                    <TableRow style={{ height: 50 }}>
                      <TableCell
                        colSpan={9}
                        style={{ textAlign: "-webkit-center" }}
                      >
                        {" "}
                        Sin Registros
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
          {openConfirmation && 
            <AlertFinalizadoStepper
              open={openConfirmation}
              pregunta={"Anulación de Factura"}
              dialogText={`Se va a proceder a anular la factura Nro ${selectedFactAnular.nroComprobante2}. Está seguro?`}
              esFactura={true}
              showTextarea={true}
              textBoxPlaceholder={"Motivo de Anulación..."}
              value={observacionAnulacion}
              setObservacion={setObservacionAnulacion}
              buttonCancel={"Cancelar"}
              buttonSubmit={"Continuar"}
              handleClose={handleCloseConfirmation}
              handleSend={handleSendConfirmation}
            />
          }
          {openValidation && 
            <AlertFinalizadoStepper
              open={openValidation}
              pregunta={"Validación datos"}
              dialogText={`Ingrese el DNI del Usuario loqueado`}
              buttonCancel={"Cancelar"}
              buttonSubmit={"Confirmar"}
              showTextBox={true}
              textBoxValue={dniUser}
              setTextBoxValue={setDniUser}
              textBoxLabel={'Nro. Doc. Usuario'}
              handleClose={handleCloseValidation}
              handleSend={handleSendValidation}
            />
          }
        </React.Fragment>
      )}
    </>
  );
};
